import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../Pais/actions'
import { Field } from 'redux-form'
import {
  renderSelectField
} from '../../fieldRenderers'

class PaisDropdown extends Component {
  constructor (props) {
    super(props)
    this.renderPaises = this.renderPaises.bind(this)
    this.onSelect = this.onSelect.bind(this)
  };

  componentDidMount () {
    this.props.requestPaises()
  };

  onSelect (paises) {
    if (paises) {
      this.props.setPais(paises.target.value)
    }
  }

  renderPaises () {
    const {
      paises
    } = this.props
    return [
      (
        <option
          value='UNDEF'
          key='UNDEF'
        >
        Seleccione un Pais
        </option>
      ),
      ...paises.map(pais => {
        return (
          <option
            value={pais.nombreCorto}
            key={pais.nombreCorto}
          >
            {pais.nombre}{' (' + pais.nombreCorto + ') '}
          </option>
        )
      })
    ]
  };

  render () {
    const {
      isRequesting,
      disabled,
      label = null,
      name = null,
      required = false
    } = this.props

    const textLabel = required ? (label ? `${label} *` : 'Bandera *') : (label || 'Bandera')

    return (
      <Field
        onChange={this.onSelect}
        name={name || 'pais'}
        label={textLabel}
        disabled={disabled}
        component={renderSelectField}
        placeholder='Seleccione una Pais'>
        {!isRequesting ? this.renderPaises() : null}
      </Field>
    )
  }
}

const mapStateToProps = (state) => ({
  isRequesting: state.pais.isRequestingPaises,
  paises: state.pais.paises
})

const withRedux = connect(mapStateToProps, actions)

export default withRedux(PaisDropdown)
